@if(count() > 0){   
  <count-badge [count]="count()"></count-badge>
}

<!--style="opacity: 0.4; pointer-events: none; cursor: not-allowed;"-->
<span 
  role="button"
  class="material-icons-sharp font-8 mt-1 primary-text-100 ms-3"     
  (click)="toggle()">notifications_none</span>
